<template>
  <div
    id="answer-container"
    class="col d-flex justify-content-end align-items-center"
  >
    <template v-if="!resolution">
      <div
        v-for="(item, index) in answers"
        :key="item.label"
        :class="{
          'active text-white': currentAnswer.index === index,
          disabled: submitted,
        }"
        class="question-section question-answer text-center d-flex justify-content-center align-items-center mr-3 flex-column"
        @click="checkAnswer(item, index)"
      >
        <em
          :class="{
            'far fa-check-circle': currentAnswer.index === index,
            'far fa-circle': currentAnswer.index != index,
          }"
        />
        <span class="answer-title">{{ item.label }}</span>
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-items-center flex-column">
        <label class="font-weight-bold">
          Manera en que se resolvió la controversia
        </label>
        <select
          v-model="itemOfResolution"
          class="form-control mb-1"
          :class="{ 'validation-error': !isValid }"
          :disabled="submitted"
          @change="selectResolution($event)"
        >
          <option disabled :value="null">
            Seleccione
          </option>
          <option
            v-for="option in lisfOfResolutions"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>

        <small v-if="!isValid" class="text-danger w-100">
          <em class="fas fa-times-circle mr-2" />
          Favor Seleccionar
        </small>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'AnswerBox',
  props: {
    answer: {
      type: Object,
      required: true,
      default: () => {},
    },
    resolution: {
      type: Boolean,
      default: () => false,
    },
    parentQuestion: {
      type: Object,
      default: null,
    },
    resolutionsList: {
      type: Array,
      default: () => [],
    },
    isValid: {
      type: Boolean,
      default: () => true,
    },
    submitted: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      currentAnswer: {
        answer: this.answer.response,
        index: this.answer.index,
        value: this.answer.value,
      },
      disabled: null,
      answers: [
        { label: 'SI', value: true },
        { label: 'NO', value: false },
      ],
      parentItem: this.parentQuestion,
      result: this.answer,
      lisfOfResolutions: this.resolutionsList,
      itemOfResolution: null,
    };
  },
  mounted() {
    this.updateAnswer();
    if (this.lisfOfResolutions.length > 0) {
      let resolution = this.lisfOfResolutions.find((x) => x.selected);

      if (resolution) this.itemOfResolution = resolution.id;
    }
  },
  methods: {
    checkAnswer(item, idx) {
      if (this.submitted) return;

      this.currentAnswer.response = item.label == 'SI';
      this.currentAnswer.index = idx;
      this.currentAnswer.value = this.currentAnswer.response ? 'SI' : 'NO';

      if (
        this.parentItem !== null &&
        this.parentItem.relatedValue != this.parentItem.requiredValue
      ) {
        this.currentAnswer.index = -1;
        this.currentAnswer.value = null;
        this.currentAnswer.response = null;
      }

      this.$emit('changedAnswer', this.currentAnswer);
    },
    updateAnswer() {
      if (this.answer.response != null) {
        this.currentAnswer.index = this.answer.response ? 0 : 1;
        this.currentAnswer.value = this.answer.response ? 'SI' : 'NO';
        this.currentAnswer.response = this.answer.response;
      } else {
        this.currentAnswer.index = -1;
        this.currentAnswer.value = null;
        this.currentAnswer.response = null;
      }
    },
    selectResolution(event) {
      if (this.itemOfResolution != null) {
        this.lisfOfResolutions.map((x) => (x.selected = false));
        let selectedResolution = this.lisfOfResolutions.find(
          (r) => r.id === event.target.options.selectedIndex
        );
        selectedResolution.selected = true;
      }
    },
  },
};
</script>
<style scoped>
.validation-error {
  background: #f9d4da;
  border: 1px solid #de6874;
  color: black;
}
.disabled:not(.active) {
  background-color: #f2f2f2;
}
.active.disabled {
  background-color: #a6d0c0 !important;
}

.answer-title {
  display: block;
  font: Regular 11px/11px Lato;
  font-size: 10px;
  letter-spacing: 0;
  font-weight: 100;
  margin-top: 4px;
}

.active .answer-title {
  color: #fff;
}
</style>
